import { render } from "./cookieConsent.vue?vue&type=template&id=79a8863f&scoped=true"
import script from "./cookieConsent.vue?vue&type=script&lang=js"
export * from "./cookieConsent.vue?vue&type=script&lang=js"

import "./cookieConsent.vue?vue&type=style&index=0&id=79a8863f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a8863f"]])

export default __exports__